import { Page_Flexiblecontent_Blocks_PostsBlock } from "graphql";
import { Button } from "components/Button";
import { PostCard } from "components/PostCard";
import { gql, useQuery } from "@apollo/client";
import { MEDIA_ITEM_FRAGMENT } from "fragments";
import { Key, useEffect, useState } from "react";

export interface PostsBlockProps
  extends Page_Flexiblecontent_Blocks_PostsBlock {
  className?: string;
}

const PostsBlock = ({
  className,
  backgroundColor,
  variant,
  title,
  hasPawIcon,
  pawIconPosition,
  useLatestPosts,
  postsGrid,
  postsStatic,
}: PostsBlockProps) => {
  const hasItems =
    (postsGrid && postsGrid.length > 0) ||
    (postsStatic && postsStatic.length > 0);

  const isStatic = variant === `static`;
  const isGrid = variant === `grid`;
  const [postData, setPostData] = useState([] as any);
  const { data, loading, error } = useQuery(LATEST_POSTS_QUERY, {
    variables: {
      first: 3,
    },
  });

  useEffect(() => {
    if (data) {
      setPostData(data.posts.nodes);
    }
  }, [data]);

  return (
    <section
      className={`${
        className ? className : ``
      } w-full px-4 py-10 bg-${backgroundColor}`}
    >
      <div
        className={`${
          className ? className : ``
        } container mx-auto flex flex-col gap-6`}
      >
        {title ? (
          <h2 className={`text-left font-heading text-5xl text-dark`}>
            {title}
          </h2>
        ) : null}

        {hasItems && !useLatestPosts ? (
          <div className={`flex flex-col gap-3 md:flex-row`}>
            {isStatic && postsStatic ? (
              <>
                {postsStatic?.map((post) => {
                  return (
                    <PostCard
                      key={post?.id}
                      variant={`stacked`}
                      post={post as any}
                    />
                  );
                })}
              </>
            ) : null}
            {isGrid && postsGrid ? (
              <>
                {postsGrid?.map((post) => {
                  return (
                    <PostCard
                      key={post?.id}
                      variant={`stacked`}
                      post={post as any}
                    />
                  );
                })}
              </>
            ) : null}
          </div>
        ) : (
          <div className={`flex flex-col gap-3 md:flex-row`}>
            {postData &&
              postData?.map((post: { id: Key | null | undefined }) => {
                return (
                  <PostCard
                    key={post?.id}
                    variant={`stacked`}
                    post={post as any}
                  />
                );
              })}
          </div>
        )}
      </div>
    </section>
  );
};

export default PostsBlock;

const LATEST_POSTS_QUERY = gql`
  query LatestPosts($first: Int) {
    posts(first: $first) {
      nodes {
        id
        title
        uri
        excerpt
        date
        postOptions {
          isExternal
          externalLink
        }
        featuredImage {
          node {
            ...MediaItemFragment
          }
        }
      }
    }
  }
  ${MEDIA_ITEM_FRAGMENT}
`;
